<form #form="ngForm" class="container-form with-nav-tabs" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
              <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12 container-navs">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-target="#tabPrincipal" data-toggle="tab">Principal</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabCidades" data-toggle="tab">Cidades</a>
                </li>
            </ul>
            <div class="tab-content">
                <!-- Principal -->
                <div class="tab-pane active" id="tabPrincipal">
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="codigo" class="col-form-label">Código</label>
                            <input type="number" class="form-control" [value]="entity.codigo" name="codigo" id="codigo"
                            disabled="disabled" readonly="readonly">
                        </div>
                        <div class="col-12 col-md-4">
                            <label for="codigoIntegracaoErp" class="col-form-label">Código ERP</label>
                            <input type="text" class="form-control" [(ngModel)]="entity.codigoIntegracaoErp" name="codigoIntegracaoErp" id="codigoIntegracaoErp"
                                #codigoIntegracaoErp="ngModel" maxlength="50">
                            <p class="form-text text-muted">Código da região no seu sistema ERP</p>                                
                        </div>  
                        <div class="col-12 col-md" *ngIf="editMode">
                            <label for="situacao" class="col-form-label">Situação</label>
                            <sgt-regiao-situacao-select
                                [(ngModel)]="entity.situacao"
                                #situacao="ngModel"
                                name="situacao"
                                id="situacao"
                                required="required"
                                [canSelectNull]="false">
                            </sgt-regiao-situacao-select>
                            <sgt-form-control-error
                                *ngIf="situacao.errors && situacao.errors.required && situacao.dirty"
                                msgError="A situação é obrigatória">
                            </sgt-form-control-error>
                        </div>                                                
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="nome" class="col-form-label">Nome</label>
                            <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                                #nome="ngModel" required="required" maxlength="255" [autofocus]="true" sgtUppercase>
                            <sgt-form-control-error
                                *ngIf="nome.errors && nome.errors.required && nome.dirty"
                                msgError="O nome é obrigatório">
                            </sgt-form-control-error>
                            <sgt-form-control-error
                                *ngIf="nome.errors && nome.errors.maxlength"
                                msgError="O nome deve ter no máximo 255 caracteres">
                            </sgt-form-control-error>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sgt-regiao-representante
                                [entities]="entity.representantes"
                                #regiaoRepresentanteCadastro>
                            </sgt-regiao-representante>
                        </div>
                    </div>
                </div>
                <!-- End Principal -->

                <!-- Cidades -->
                <div class="tab-pane" id="tabCidades">
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="estado" class="col-form-label">Estado de Referência</label>
                            <select class="form-control" name="estado" id="estado"
                                #estado="ngModel" [ngModel]="entity.idEstado || ''" (ngModelChange)="entity.idEstado = $event ? $event : null">
                                <option value="">Selecione o estado...</option>
                                <option *ngFor="let estado of estados" [ngValue]="estado.id">{{estado.nome}}</option>
                            </select>
                            <p class="form-text text-muted">Estado de referência desta região</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <sgt-regiao-cidade
                                [entities]="entity.cidades"
                                #regiaoCidadeCadastro>
                            </sgt-regiao-cidade>
                        </div>
                    </div>
                </div>
                <!-- End Cidades -->
            </div>
        </div>
    </div>
</form>
